import { render, staticRenderFns } from "./lovelist_box.vue?vue&type=template&id=fdae131e&scoped=true&"
import script from "./lovelist_box.vue?vue&type=script&lang=js&"
export * from "./lovelist_box.vue?vue&type=script&lang=js&"
import style0 from "./lovelist_box.vue?vue&type=style&index=0&id=fdae131e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdae131e",
  null
  
)

export default component.exports